import React from 'react';
import PeriodPnLChart from './PeriodPnLChart';
import RouteMarginChart from './RouteMarginChart';
import DebtAgingCard from './DebtAgingCard';
import ChargeBreakdownChart from './ChargeBreakdownChart';
import { useLanguage } from '../../contexts/LanguageContext';
import { TrendingUp, MapPin, Clock, PieChart } from 'lucide-react';

const SectionHeader = ({ icon: Icon, title, description }) => (
  <div className="flex items-center gap-2 mb-4">
    <Icon size={18} className="text-muted-foreground" />
    <div>
      <h3 className="text-base font-semibold text-foreground">{title}</h3>
      {description && <p className="text-xs text-muted-foreground">{description}</p>}
    </div>
  </div>
);

const AnalysisDashboard = () => {
  const { t } = useLanguage();
  return (
    <div className="space-y-10">
      {/* Period P&L */}
      <section>
        <SectionHeader
          icon={TrendingUp}
          title={t('periodAnalysis')}
          description={t('periodAnalysisDesc')}
        />
        <PeriodPnLChart />
      </section>

      {/* Route Margin */}
      <section>
        <SectionHeader
          icon={MapPin}
          title={t('routeProfitability')}
          description={t('routeProfitabilityDesc')}
        />
        <RouteMarginChart />
      </section>

      {/* Debt Aging */}
      <section>
        <SectionHeader
          icon={Clock}
          title={t('debtAging')}
          description={t('debtAgingDesc')}
        />
        <DebtAgingCard />
      </section>

      {/* Charge Breakdown */}
      <section>
        <SectionHeader
          icon={PieChart}
          title={t('chargeBreakdown')}
          description={t('chargeBreakdownDesc')}
        />
        <ChargeBreakdownChart />
      </section>
    </div>
  );
};

export default AnalysisDashboard;
